import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsDateTimePickerModule } from 'src/app/common-components/date-time-picker/date-time-picker.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { AddScheduleHourComponent } from './containers/add-schedule-hour.component';
import { AddScheduleHourViewComponent } from './views/add-schedule-hour-view.component';

@NgModule({
   declarations: [AddScheduleHourComponent, AddScheduleHourViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      EntitySelectModule,
      LcsDatepickerModule,
      MatDatepickerModule,
      MatSlideToggleModule,
      LcsDateTimePickerModule,
   ],
})
export class AddScheduleHourModule {}
